import { useState } from 'react';
import { Box, CircularProgress, MenuItem } from '@material-ui/core';
import { FiMessageCircle } from 'react-icons/fi';

export const ChatMessageUserMenuItem = ({
  goToChat,
  textColor,
}: {
  goToChat: () => Promise<void>;
  textColor: string;
}) => {
  const [creatingChat, setCreatingChat] = useState(false);

  const handleClick = async () => {
    setCreatingChat(true);
    await goToChat();
    setCreatingChat(false);
  };

  return (
    <MenuItem onClick={handleClick} disabled={creatingChat}>
      <Box display="flex" alignItems="center" gridGap={8} color={textColor}>
        {creatingChat ? <CircularProgress size={14} /> : <FiMessageCircle size={14} />} Message
      </Box>
    </MenuItem>
  );
};
